import debounce from 'lodash/debounce';
import notFoundIcon from '@assets/svg/icon/not-found.svg';
import { newToastMessage } from '../ToastMessagesActions';
import { poorNetMsg, badNetTitle } from '../ToastMessagesConstants';

const POOR_NETWORK_TOAST_DEBOUNCE_DELAY = 500;

// eslint-disable-next-line import/prefer-default-export
export const poorNetworkConnectionToastMessage = debounce(
  () =>
    newToastMessage({
      title: badNetTitle,
      content: poorNetMsg(),
      iconId: notFoundIcon.url,
      poorNetworkConnection: true,
    }),
  POOR_NETWORK_TOAST_DEBOUNCE_DELAY,
  {
    leading: true,
    trailing: false,
  }
);
